import React from "react"

import { LeadSourceBudgetPage } from "../components/settings-lead-source-budget/LeadSourceBudgetPage.tsx"

export default function SettingsLeadSourceBudgetPage() {
  return <LeadSourceBudgetPage />
}
